// ============================================================================
// SPANISH TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "La Unidad que Produce Paz",
    author: "Por Emmanuel",
    subtitle: "Cada religión tiene sus razones, nuestras fronteras vienen del pasado",
    description: "Módulo de reflexión sobre la unidad espiritual y la paz entre tradiciones",
    
    nav: {
      intro: "Intro",
      religions: "Religiones",
      common: "Bases Comunes",
      humility: "Humildad"
    },

    intro: {
      emmanuelSays: "Emmanuel dice:",
      ourBordersFromPast: "Nuestras fronteras vienen del pasado",
      bordersDescription: "Cada religión tiene sus razones. Nuestras divisiones no son la voluntad divina, sino el fruto de la historia, la geografáa, la cultura.",
      divisionWork: "La división, el aislamiento por barreras y fronteras de miedo, es obra de nuestro peligroso pasado.",
      sharedHumanity: "Nacemos en tradiciones diferentes, pero compartimos la misma humanidad.",
      
      revelationTitle: "Una revelación que abre los ojos",
      surprisedLearning: "Me sorprendá un día al aprender que los judáos también son hijos de Dios.",
      angelMichael: "Que el ángel Miguel es un gran mensajero para los musulmanes.",
      jesusNames: "Que Jesús, Isa, Yeshua son conocidos de diversas maneras, incluso en la fe cristiana.",
      diverseTribes: "Porque existen diversas tribus, diversas iglesias, diversas familias.",
      sameRealities: "Hablamos de las mismas realidades con nombres diferentes. Esto deberáa acercarnos, no dividirnos.",
      
      respectTitle: "El respeto: base de la humildad, guardián de la paz",
      respectFoundation: "Aunque la fraternidad no sea objetivamente aplicable, el respeto es la base de la humildad, guardián de la paz.",
      understandingProcess: "Comprender y respetar otras religiones es un proceso de humildad. No significa renunciar a tu fe, sino aceptar que el otro también busca la verdad.",
      
      whatBindsUs: "Lo que realmente nos une",
      seekingRelation: "Cada religión busca la relación. Cada hombre busca la paz.",
      loveOfGod: "Esta relación que nos une a todos es el amor de Dios.",
      universalLink: "El amor es el vánculo universal que trasciende todas las fronteras, todos los idiomas, todas las tradiciones.",
      
      inclusionTitle: "La inclusión: aún más vasta que la diversidad religiosa",
      vastInclusion: "La diversidad religiosa es vasta, pero aún más vasta es la inclusión de los demás donde son llamados por Dios.",
      respectDifferences: "El respeto por las diferencias de color, de géneros, la inclusión nos hace humanos únicos, amados por Dios.",
      jesusCommand: "Jesús dijo: 'Amaos los unos a los otros.'",
      
      communitySpirit: "Romper con el espáritu comunitario",
      communityTerror: "El comunitarismo es el terror del odio del mal disfrazado. Transforma la fe en identidad tribal, en muro que separa, en arma que hiere.",
      pridePolitics: "Nuestros espáritus de partido nos empujan a la polática del orgullo:",
      prideQuotes: "Tengo razón de hacerte daño. Tengo razón punto. Tengo razón de hacer buena guerra.",
      watchHeart: "Cuidado con el corazón del problema, la raáz de nuestro propio mal.",
      refuseDivision: "Rechacemos esta deriva que divide a la humanidad en nombre de Dios.",
      
      freedomTitle: "Para ser libres, hacer libres a los demás",
      freedomOthers: "Para ser libres, hay que saber hacer libres a los demás también.",
      defendFreedom: "Mi libertad de creer solo tiene valor si defiendo la de todos. Oprimir al otro es condenarme a má mismo a la servidumbre.",
      
      changeHeartTitle: "Cambia tu corazón: sé una verdadera linterna",
      recognizeDecency: "Reconocer que la decencia no es la misma para cada uno.",
      changeYourself: "Cambio de ti primero, progresivamente. Cambia tu corazón, transforma tu vida, sé una verdadera linterna.",
      beExample: "No harás pipá en el césped, porque perecerá... No impongas tus reglas a los demás, sino conviértete en un ejemplo vivo por tu transformación.",
      
      childrenPeaceTitle: "Nuestros hijos vivirán en paz en la diversidad",
      avoidPursuit: "Evitar la persecución de palabras por palabras.",
      peaceChoice: "Si elegimos el respeto hoy, nuestros hijos del futuro vivirán en paz en la diversidad. La paz comienza por nosotros, ahora, en nuestras palabras y actos.",
      
      discernTitle: "Discernir: el hombre o Dios?",
      manSpeaks: "Demasiadas veces, es el corazón del hombre el que habla y divide.",
      seeFruits: "Lo vemos por el fruto de las palabras y las palabras: el robo, la destrucción, las guerras. Cuidado con la manipulación de palabras para competir por el propio orgullo.",
      
      lookPeaceTitle: "Mirar a la paz y al amor",
      lookPeaceAll: "Mirar a la paz para todos, mirar al amor de Dios por los demás.",
      godSpeaks: "Cuando las palabras producen paz, reconciliación, unidad: es Dios quien habla. Cuando producen división, odio, guerra: es el orgullo del hombre.",
      
      watchWordsTitle: "Vigilar nuestras palabras",
      watchShares: "Vigilar nuestros compartires, vigilar nuestras palabras contrarias dañinas hacia los demás.",
      disqualify: "Estos males nos descalifican. Los frutos de nuestras palabras revelan quién habla en nosotros: Dios o nuestro propio orgullo?",
      
      wisdomMaturityTitle: "Sabiduría y madurez frente a nuestra naturaleza",
      useScriptures: "Usar las escrituras (las leyes) para hacer daño es nuestro hábito, un proceso casi natural y travieso.",
      hateSin: "Frente a nuestra naturaleza pecadora, aborrecemos el mal y las personas que hacen el mal.",
      separateActs: "Pero por sabiduría y madurez, debemos separar los actos de nuestra pobreza humana.",
      compassionNature: "Reconocer nuestra naturaleza animal que necesita compasión y gracia, mientras nos protegemos según los contextos.",
      
      denounceLeadersTitle: "Denunciar a los láderes espirituales corruptos",
      watchLeaders: "Cuidado con los láderes espirituales o dirigentes que buscan mantener en secreto su deriva y deshonestidad.",
      noJustice: "Sin justicia, no hay ejemplo. Sin conocimiento, otras váctimas perecen por nuestro silencio.",
      silenceComplicity: "El silencio frente a la injusticia es complicidad. La verdad debe ser dicha para proteger a los demás."
    },

    religions: {
      title: "Diversas Religiones, una Humanidad",
      intro: "Cristianos, Musulmanes, Judáos, Hindúes, Budistas... y muchos otros: todos buscan la verdad",
      theirGod: "Su Dios:",
      theGood: "El Bien:",
      theEvil: "El Mal:",
      theAngels: "Los Ángeles:",
      theUnity: "La Unidad:",
      values: "Valores:",
    commonGoal: "Objetivo Común",
    seekingPeace: "Todas las religiones comparten un objetivo común: buscar la paz, promover el amor y construir un mundo mejor. Más allá de nuestras diferencias, todos estamos unidos en esta búsqueda de sabiduría y armonía.",
      
      christianity: {
        name: "Cristianismo",
        godText: "Un Dios único, Padre creador",
        goodText: "El amor al prójimo, el perdón, la paz",
        evilText: "El odio, el egoásmo, la violencia",
        angelsText: "Los mensajeros de Dios (Gabriel, Miguel...)",
        unityText: "Un solo Dios para todos los hombres",
        values: "Amor,Perdón,Paz,Humildad,Justicia"
      },
      islam: {
        name: "Islam",
        godText: "Alá, el Único y Misericordioso",
        goodText: "La justicia, la caridad, la paz",
        evilText: "La opresión, la mentira, la división",
        angelsText: "Los ángeles de luz (Yibril, Mikail...)",
        unityText: "No hay más dios que Alá",
        values: "Paz,Justicia,Caridad,Respeto,Misericordia"
      },
      judaism: {
        name: "Judaásmo",
        godText: "YHWH, el Eterno único",
        goodText: "La justicia, la compasión, la vida",
        evilText: "La opresión, la calumnia, el odio",
        angelsText: "Los mensajeros celestiales (Malakhim)",
        unityText: "Escucha Israel, el Eterno es Uno",
        values: "Justicia,Vida,Memoria,Paz,Estudio"
      },
      hinduism: {
        name: "Hinduismo",
        godText: "Brahman, la realidad suprema",
        goodText: "La no violencia (ahimsa), el deber justo",
        evilText: "La violencia, la ignorancia espiritual",
        angelsText: "Los Devas, seres celestiales benevolentes",
        unityText: "Todo es Uno en Brahman",
        values: "No-violencia,Verdad,Compasión,Pureza,Armonáa"
      },
      buddhism: {
        name: "Budismo",
        godText: "No hay dios creador, pero respeto por lo sagrado",
        goodText: "La compasión, la sabiduría, la paz",
        evilText: "El sufrimiento causado por la ignorancia",
        angelsText: "Los Bodhisattvas, seres iluminados",
        unityText: "Naturaleza de Buda en cada uno",
        values: "Compasión,Sabiduría,Paz,No-violencia,Despertar"
      }
    },

    common: {
      title: "Las Bases Comunes",
      intro: "El Bien, el Mal, los Ángeles, Un Dios Único, la Relación, la Inclusión: lo que une a la humanidad",
      
      goodTitle: "El Bien",
      goodDescription: "Todas las religiones enseñan el amor, la justicia y la compasión",
      goodExamples: "Amar a tu prójimo como a ti mismo|Hacer el bien sin distinción|Proteger a los débiles y oprimidos|Decir la verdad con bondad|Compartir lo que tienes",
      
      evilTitle: "El Mal",
      evilDescription: "Todas condenan la violencia, la mentira y la opresión",
      evilExamples: "Matar sin justicia|Robar y explotar|Mentir y calumniar|Despreciar y humillar|Dividir y odiar",
      
      angelsTitle: "Los Ángeles y Seres Espirituales",
      angelsDescription: "Casi todas reconocen mensajeros celestiales benevolentes",
      angelsExamples: "Ángeles mensajeros de Dios|Guáas espirituales|Seres de luz|Protectores celestiales|Bodhisattvas y Devas",
      
      godTitle: "Un Dios Único (o Realidad Suprema)",
      godDescription: "La mayoría cree en una fuente única, un creador o una realidad última",
      godExamples: "Cristianismo, Islam, Judaísmo: Un solo Dios|Hinduismo: Brahman, el Uno supremo|Budismo: Naturaleza de Buda universal|Todos buscan la verdad última|Todos aspiran a la unidad y la paz",
      
      relationTitle: "La Relación y la Paz",
      relationDescription: "Lo que realmente une a todas las religiones y a todos los hombres",
      relationExamples: "Cada religión busca la relación con lo divino|Cada hombre busca la paz|Esta relación que nos une a todos es el amor de Dios|El amor es el vánculo universal|La paz es nuestra aspiración común",
      
      inclusionTitle: "La Inclusión: Amados por Dios",
      inclusionDescription: "La diversidad religiosa es vasta, pero aún más vasta es la inclusión",
      inclusionExamples: "Inclusión de los demás donde son llamados por Dios|Respeto por las diferencias de color|Respeto por las diferencias de géneros|La inclusión nos hace humanos únicos, amados por Dios|Jesús dijo: 'Amaos los unos a los otros'",
      
      finalQuote: "Me sorprendá un día al aprender que los judáos también son hijos de Dios, que el ángel Miguel es un gran mensajero para los musulmanes, que Jesús, Isa, Yeshua son conocidos de diversas maneras incluso en la fe cristiana. Porque existen diversas tribus, diversas iglesias, diversas familias.",
      finalQuote2: "Hablamos de las mismas realidades con nombres diferentes.",
      quoteAuthor: "Emmanuel, La Unidad que Produce Paz"
    },

    humility: {
      title: "7 Pasos hacia la Humildad y la Paz",
      intro: "El proceso para superar el comunitarismo y convertirse en una verdadera linterna",
      
      step: "Paso",
      action: "Acción:",
      
      step1Title: "Reconocer: nuestras fronteras vienen del pasado",
      step1Description: "La división, el aislamiento por barreras y fronteras de miedo, es obra de nuestro peligroso pasado. Nuestras divisiones no son la voluntad de Dios.",
      step1Action: "Aceptar que mi tradición es solo máa, y formo parte de la diversidad querida por Dios",
      
      step2Title: "El respeto: base de la humildad, guardián de la paz",
      step2Description: "Aunque la fraternidad no sea objetivamente aplicable, el respeto es el fundamento.",
      step2Action: "Respetar todas las creencias, incluso sin comprenderlo todo",
      
      step3Title: "Comprender sin juzgar",
      step3Description: "Hoy, comprender a los demás es un proceso de humildad necesario.",
      step3Action: "Escuchar realmente lo que los demás creen, sin juzgar",
      
      step4Title: "Cambio de ti primero: sé una verdadera linterna",
      step4Description: "Reconocer que la decencia no es la misma para cada uno. Cambia tu corazón progresivamente, transforma tu vida, conviértete en una verdadera luz.",
      step4Action: "No imponer mis reglas a los demás, sino ser un ejemplo vivo por mi transformación",
      
      step5Title: "Romper con el espáritu comunitario",
      step5Description: "Nuestros espáritus de partido nos empujan a la polática del orgullo: 'Tengo razón de hacerte daño, tengo razón punto.' Cuidado con el corazón del problema, la raáz de nuestro propio mal.",
      step5Action: "Rechazar los discursos de división en mi propia comunidad",
      
      step6Title: "Para ser libre, hacer libre a los demás",
      step6Description: "Mi libertad depende de la que concedo a los demás.",
      step6Action: "Defender la libertad de conciencia de todos, no solo la máa",
      
      step7Title: "Evitar la persecución de palabras por palabras",
      step7Description: "No responder al odio con odio, a los insultos con insultos.",
      step7Action: "Elegir la paz para que nuestros hijos vivan en paz en la diversidad",
      
      discernFruits: "Discernir por los Frutos",
      humanHeart: "El corazón del hombre que divide",
      lookGodLove: "Mirar al amor de Dios",
      watchOurWords: "Vigilar nuestras Palabras",
      
      prideFruits: "Frutos del orgullo humano",
      prideFruitsList: "Espíritu de partido: \"Tengo razón, punto\"|Política del orgullo: \"Tengo razón de hacerte daño\"|Usar las escrituras para hacer daño (proceso travieso)|Odiar a las personas (no solo los actos)|Líderes espirituales que ocultan su deriva y deshonestidad|Silencio cómplice ante la injusticia|División y guerras|Odio disfrazado de piedad|Robo y destrucción|Manipulación por orgullo|Desprecio y violencia",
      
      godFruits: "Frutos del amor de Dios",
      godFruitsList: "Separar los actos de la persona con sabiduría|Compasión por nuestra pobreza humana|Gracia mientras nos protegemos según los contextos|Denunciar la injusticia para proteger a otros|Decir la verdad con valentía|Paz para todos|Amor sin distinción|Reconciliación y unidad|Humildad y respeto|Libertad para todos",
      
      finalQuote: "Aunque la fraternidad no sea objetivamente aplicable, el respeto es la base de la humildad, guardián de la paz. Evitar la persecución de palabras por palabras, y nuestros hijos del futuro vivirán en paz en la diversidad.",
      author: "Emmanuel"
    },

    footer: {
      quote: "El respeto es la base de la humildad, guardián de la paz. Nuestros hijos vivirán en paz en la diversidad si elegimos el respeto hoy.",
      author: "Emmanuel, La Unidad que Produce Paz"
    }
};

export default unityTranslations;
